import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Avatar,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Container,
  IconButton,
} from "@mui/material";
import { ConsultantuseAuth } from "../../security/ConsultantUseAuth";
import { ArrowBack, ArrowForward } from "@mui/icons-material";

import { Consultant_Get_One_From_MongoDB } from "../../api/Consultant_Get_One_From_MongoDB";
import GetClientAddress from "../../../functions/GetClientAddress";
import { Get_One_From_MongoDB } from "../../api/Get_One_From_MongoDB";
import { Consultant_Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort } from "../../api/Consultant_Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort";
import { Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort } from "../../api/Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort";

import { Get_All_From_MongoDB_With_Search_Prop_In_Array } from "../../api/Get_All_From_MongoDB_With_Search_Prop_In_Array";
import { Arr_SEFPages } from "../../../arrays/SEF/Arr_SEFPages";

import ConsultantLetterTable from "./components/ConsultantLetterTable";
import ConsultantLetterCards from "./components/ConsultantLetterCards";
import { Request_Letter } from "./api/Request_Letter";
import { Get_All_From_MongoDB_Choose_Fields_With_Search_Prop_In_Array } from "../../api/Get_All_From_MongoDB_Choose_Fields_With_Search_Prop_In_Array";
import { Get_One_Choose_Fields_From_MongoDB } from "../../api/Get_One_Choose_Fields_From_MongoDB";
import { Get_All_Non_Archived_Attendees_From_Array } from "../../api/Get_All_Non_Archived_Attendees_From_Array";

const ConsultantLetters = () => {
  const { logoutConsultant } = ConsultantuseAuth();

  //------------------------------------------Width Stuff

  let widthLimit = 1000;
  const [screenWidth, setscreenWidth] = useState(
    window.innerWidth <= widthLimit ? "Small" : "Big"
  );

  useEffect(() => {
    const handleResize = () => {
      setscreenWidth(window.innerWidth <= widthLimit ? "Small" : "Big");
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  function isMobile() {
    return (
      /Mobi|Android|iPhone|iPad|iPod|BlackBerry|Opera Mini|IEMobile|WPDesktop/i.test(
        navigator.userAgent
      ) || screenWidth === "Small"
    );
  }

  const [View, setView] = useState(isMobile() ? "Cards" : "Table");

  ///--------------------GET EC DATA--------

  const [obj_EC, setobj_EC] = useState({});
  useEffect(() => {
    const fetchECData = async () => {
      Get_One_From_MongoDB(
        "IP",
        "EC",
        localStorage.getItem("Consultant_id"),
        setobj_EC,
        logoutConsultant
      );
    };
    fetchECData();
  }, []);

  //Get Agency Data
  const [obj_Agency, setobj_Agency] = useState({});
  useEffect(() => {
    if (obj_EC.MetaData?.Agency_id && obj_EC.MetaData.Agency_id.length > 0) {
      Get_One_Choose_Fields_From_MongoDB(
        "IP",
        "Agencies",
        obj_EC.MetaData.Agency_id,
        {
          "MetaData.IP_id": 1,
          _id: 1,
          BasicInfo: 1,
        },
        setobj_Agency
      );
    }
  }, [obj_EC]);
  //Get All ECs if Admin
  const [Arr_ECs, setArr_ECs] = useState([]);
  useEffect(() => {
    if (obj_EC.MetaData?.Admin === "Yes") {
      const fetchAttendeeData = async () => {
        Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort(
          "IP",
          "EC",
          { "MetaData.Agency_id": obj_EC.MetaData?.Agency_id },
          100,
          setArr_ECs,
          {},
          { _id: 1, BasicInfo: 1 },
          logoutConsultant
        );
      };
      fetchAttendeeData();
    }
  }, [obj_EC]);
  //Part 1, get bookings data
  const [Arr_Bookings, setArr_Bookings] = useState([]);
  useEffect(() => {
    const fetchAttendeeData = async () => {
      if (obj_EC.MetaData?.Admin === "Yes") {
        let Arr_ECs_IDs = Arr_ECs.map((obj) => obj._id);
        Get_All_Non_Archived_Attendees_From_Array(
          "Registers_2025",
          "All",
          "IPInfo.EC_ID",
          Arr_ECs_IDs,
          {
            BasicInfo: 1,
            Contacts: 1,
            IPInfo: 1,
            SEFProgress: 1,
            VISA: 1,
            SEFInfo: 1,
            Notes: 1,
          },
          setArr_Bookings,
          logoutConsultant
        );
      } else {
        Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort(
          "Registers_2025",
          "All",
          {
            "IPInfo.EC_ID": localStorage.getItem("Consultant_id"),
            "MetaData.Archived": { $ne: "Yes" },
          },
          1000,
          setArr_Bookings,
          {},
          {
            BasicInfo: 1,
            Contacts: 1,
            IPInfo: 1,
            SEFProgress: 1,
            VISA: 1,
            SEFInfo: 1,
            Notes: 1,
          },
          logoutConsultant
        );
      }
    };
    fetchAttendeeData();
  }, [obj_EC, Arr_ECs]);

  //filter out weekends and anyone with Archived value of "Yes"

  let Arr_Bookings_Filtered = Arr_Bookings.filter(
    (obj_booking) =>
      !obj_booking.BasicInfo?.ProgrammeTitle.toLowerCase().includes(
        "weekend"
      ) && obj_booking.MetaData?.Archived !== "Yes"
  );

  //------------------send letter--------
  function handleRequestLetter(e, Letter, Attendee) {
    e.preventDefault();
    e.target.disabled = true;
    e.target.style.backgroundColor = "grey";
    e.target.innerText = "Requested";
    //
    let newNote = {
      DateTime: new Date().toISOString(),
      Note: Letter + " Sent to EC",
      Staff_ID: obj_EC.BasicInfo?.Email,
    };
    //
    Request_Letter(
      Attendee,
      Letter,
      [obj_EC.BasicInfo?.Email],
      [],
      newNote,
      logoutConsultant
    );
  }

  function handleOpenVISAPage(e, obj_booking, obj_SEFPage) {
    e.preventDefault();
    window.open(
      `${GetClientAddress()}Consultant/ViewSEFVISAInfo/${obj_booking._id}`,
      "_blank"
    );
  }

  return (
    <div>
      <link rel="stylesheet" href="https://www.w3schools.com/w3css/4/w3.css" />
      <link
        rel="stylesheet"
        href="https://www.w3schools.com/lib/w3-theme-black.css"
      />
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
      />
      <style jsx>{`
        #BookingTable {
          font-family: Arial, Helvetica, sans-serif;
          border-collapse: collapse;
          width: 100%;
        }

        #BookingTable td,
        #BookingTable th {
          border: 1px solid #ddd;
          padding: 8px;
        }

        #BookingTable tr:nth-child(even) {
          background-color: #ffffff;
        }

        #BookingTable tr:hover {
          background-color: #ddd;
        }

        #BookingTable th {
          padding-top: 12px;
          padding-bottom: 12px;
          background-color: #04aa6d;
          color: white;
        }
      `}</style>

      {/* <!-- Bookings --> */}
      <div
        className="w3-row-padding w3-padding-64 w3-theme-l5 w3-center"
        id="Bookings"
        style={{ position: "relative", minHeight: "100vh" }}
      >
        <h1>Get VISA and Acceptance Letters</h1>
        <p>
          Here you can request a VISA or Acceptance Letter.
          <br></br>The Request Acceptance Letter With Payment Line" will add the
          extra line{" "}
          <i>
            "Once the total fees have been paid, InvestIN will secure their
            place on the programme register."
          </i>{" "}
          to the acceptance letter.
          <br></br>
        </p>
        {View === "Table" ? (
          <button onClick={(e) => setView("Cards")} style={{ width: "25%" }}>
            Cards View
          </button>
        ) : (
          <button onClick={(e) => setView("Table")} style={{ width: "25%" }}>
            Table View
          </button>
        )}
        <br></br>
        <br></br>
        {View === "Table" ? (
          <>
            <ConsultantLetterTable
              Arr_Bookings={Arr_Bookings_Filtered}
              obj_EC={obj_EC}
              handleRequestLetter={handleRequestLetter}
              handleOpenVISAPage={handleOpenVISAPage}
              Arr_ECs={Arr_ECs}
            />
          </>
        ) : (
          <>
            <ConsultantLetterCards
              Arr_Bookings={Arr_Bookings_Filtered}
              screenWidth={screenWidth}
              obj_EC={obj_EC}
              handleRequestLetter={handleRequestLetter}
              handleOpenVISAPage={handleOpenVISAPage}
              Arr_ECs={Arr_ECs}
            />
          </>
        )}
      </div>

      {/* <!-- Footer --> */}
      <footer className="w3-container w3-padding-32 w3-theme-d1 w3-center">
        <h4>Follow Us</h4>
        <a
          className="w3-button w3-large w3-teal"
          href="https://www.facebook.com/@investineducation/"
          title="Facebook"
        >
          <i className="fa fa-facebook"></i>
        </a>
        <a
          className="w3-button w3-large w3-teal"
          href="https://twitter.com/investin_ed"
          title="Twitter"
        >
          <i className="fa fa-twitter"></i>
        </a>

        <a
          className="w3-button w3-large w3-teal"
          href="https://www.instagram.com/investin_education/?hl=en"
          title="Instagram"
        >
          <i className="fa fa-instagram"></i>
        </a>
        <a
          className="w3-button w3-large w3-teal w3-hide-small"
          href="https://uk.linkedin.com/company/investin"
          title="Linkedin"
        >
          <i className="fa fa-linkedin"></i>
        </a>
        <a
          className="w3-button w3-large w3-teal"
          href="https://investin.org/"
          title="Website"
        >
          <i className="fa fa-globe"></i>
        </a>
      </footer>
    </div>
  );
};

export default ConsultantLetters;
